import { render, staticRenderFns } from "./cipinlv.vue?vue&type=template&id=2068e329&scoped=true&"
import script from "./cipinlv.vue?vue&type=script&lang=js&"
export * from "./cipinlv.vue?vue&type=script&lang=js&"
import style0 from "./cipinlv.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./cipinlv.vue?vue&type=style&index=1&id=2068e329&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2068e329",
  null
  
)

export default component.exports